type EventCallback = (...args: any[]) => void;

class EventBus {
  private events: Record<string, EventCallback[]> = {};

  on(event: string, callback: EventCallback) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(callback);
    
    // Return unsubscribe function
    return () => this.off(event, callback);
  }

  off(event: string, callback: EventCallback) {
    if (!this.events[event]) return;
    this.events[event] = this.events[event].filter(cb => cb !== callback);
  }

  emit(event: string, ...args: any[]) {
    const eventCallbacks = this.events[event];
    if (!eventCallbacks || eventCallbacks.length === 0) return;
    
    // Create a copy of callbacks to safely iterate
    const callbacks = eventCallbacks.slice();
    callbacks.forEach(callback => {
      try {
        callback(...args);
      } catch (e) {
        console.error(`Error in event handler for "${event}":`, e);
      }
    });
  }
}

export const appEventBus = new EventBus();
